import { render } from "./multi-tab.vue?vue&type=template&id=732518f0&scoped=true"
import script from "./multi-tab.vue?vue&type=script&lang=ts"
export * from "./multi-tab.vue?vue&type=script&lang=ts"

import "./multi-tab.vue?vue&type=style&index=0&id=732518f0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-732518f0"

export default script